import SkeletonView from 'conversations-skeleton-state/components/SkeletonView';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { HR } from 'foundations-components/transitional/components/HR';
import { Fragment } from 'react';
import styled from 'styled-components';
import { VIEW_SELECTOR_BREAK_POINT, VIEW_SELECTOR_COLLAPSED_WIDTH, VIEW_SELECTOR_FULL_WIDTH } from 'svh-workspace-ui-lib/collapsable-sidebar/public';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadViewHeader = ({
  children
}) => /*#__PURE__*/_jsx(Flex, {
  alignItems: "center",
  blockSize: "43px",
  paddingInlineStart: "600",
  paddingInlineEnd: "700",
  marginBlockStart: "200",
  children: children
});
ThreadViewHeader.displayName = 'ThreadViewHeader';
const ThreadListItemPlaceholder = ({
  children
}) => /*#__PURE__*/_jsx(Flex, {
  alignItems: "center",
  minBlockSize: "40px",
  maxBlockSize: "40px",
  paddingInlineStart: "300",
  paddingInlineEnd: "500",
  paddingBlockStart: "200",
  paddingBlockEnd: "200",
  children: children
});
ThreadListItemPlaceholder.displayName = 'ThreadListItemPlaceholder';
const CollapsedWrapper = styled.div.withConfig({
  displayName: "ViewSelectorSidebarSkeletonState__CollapsedWrapper",
  componentId: "sc-13el29k-0"
})(["@media (min-width:", "px){display:none;}"], VIEW_SELECTOR_BREAK_POINT);
const FullWrapper = styled.div.withConfig({
  displayName: "ViewSelectorSidebarSkeletonState__FullWrapper",
  componentId: "sc-13el29k-1"
})(["@media (max-width:", "px){display:none;}"], VIEW_SELECTOR_BREAK_POINT);
const ViewSelectorSidebarSkeletonState = () => {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(CollapsedWrapper, {
      children: /*#__PURE__*/_jsx(Flex, {
        inlineSize: `${VIEW_SELECTOR_COLLAPSED_WIDTH}px`,
        backgroundColor: "fill-surface-default",
        flexDirection: "column",
        alignItems: "center",
        blockSize: "100%",
        borderInlineEndWidth: "100",
        borderInlineEndStyle: "solid",
        borderInlineEndColor: "border-primary-subtle",
        children: /*#__PURE__*/_jsx(SkeletonView, {
          blockSize: "1.5em",
          inlineSize: "1.5em",
          marginBlockStart: "400",
          marginInline: "auto"
        })
      })
    }), /*#__PURE__*/_jsx(FullWrapper, {
      children: /*#__PURE__*/_jsxs(Flex, {
        inlineSize: `${VIEW_SELECTOR_FULL_WIDTH}px`,
        backgroundColor: "fill-surface-default",
        flexDirection: "column",
        blockSize: "100%",
        borderInlineEndWidth: "100",
        borderInlineEndStyle: "solid",
        borderInlineEndColor: "border-primary-subtle",
        children: [/*#__PURE__*/_jsx(ThreadViewHeader, {
          children: /*#__PURE__*/_jsx(SkeletonView, {
            blockSize: "1em",
            inlineSize: "100%"
          })
        }), /*#__PURE__*/_jsxs(View, {
          paddingInlineStart: "300",
          children: [/*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
            children: /*#__PURE__*/_jsx(SkeletonView, {
              blockSize: "1em",
              inlineSize: "100%"
            })
          }), /*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
            children: /*#__PURE__*/_jsx(SkeletonView, {
              blockSize: "1em",
              inlineSize: "90%"
            })
          }), /*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
            children: /*#__PURE__*/_jsx(SkeletonView, {
              blockSize: "1em",
              inlineSize: "80%"
            })
          }), /*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
            children: /*#__PURE__*/_jsx(SkeletonView, {
              blockSize: "1em",
              inlineSize: "70%"
            })
          }), /*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
            children: /*#__PURE__*/_jsx(SkeletonView, {
              blockSize: "1em",
              inlineSize: "60%"
            })
          }), /*#__PURE__*/_jsx(HR, {
            distance: "small",
            marginInlineEnd: "300",
            color: "border-primary-subtle"
          }), /*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
            children: /*#__PURE__*/_jsx(SkeletonView, {
              blockSize: "1em",
              inlineSize: "80%"
            })
          }), /*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
            children: /*#__PURE__*/_jsx(SkeletonView, {
              blockSize: "1em",
              inlineSize: "100%"
            })
          }), /*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
            children: /*#__PURE__*/_jsx(SkeletonView, {
              blockSize: "1em",
              inlineSize: "60%"
            })
          })]
        })]
      })
    })]
  });
};
ViewSelectorSidebarSkeletonState.displayName = 'ViewSelectorSidebarSkeletonState';
export default ViewSelectorSidebarSkeletonState;